import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CdsIconModule } from '@cds/ng-web-components/icon';

export interface CdInlineNoticeLine {
  text?: string;
  boldText?: string;
  suffixText?: string;
}

@Component({
  selector: 'app-cd-inline-notice',
  templateUrl: './cd-inline-notice.component.html',
  styleUrls: ['./cd-inline-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdsIconModule],
})
export class CdInlineNoticeComponent {
  @Input() title = '';
  @Input() body = '';
  @Input() bodyLines: string[] = [];
  @Input() richBodyLines: CdInlineNoticeLine[] = [];
  @Input() dismissible = true;
  @Output() dismiss = new EventEmitter<void>();

  onDismiss(): void {
    this.dismiss.emit();
  }

  hasRichBodyLineContent(line: CdInlineNoticeLine): boolean {
    return !!(line.boldText || line.text || line.suffixText);
  }
}
